<nuc-dropdown
    #dropDown
    [items]="dropdownItems"
    [total]="total"
    (requestData)="getItems($event)"
    [placeholder]="'Filter by ' + (dataFilter.displayName | lowercase) + '(s)'">
</nuc-dropdown>
